import React from 'react';
import FadeIn from '../ui/FadeIn';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiStar, FiCompass, FiCamera, FiHome, FiUsers } = FiIcons;

const LastMinute = () => {
  const points = [
    { icon: FiStar, text: "Carefully Curated Details" },
    { icon: FiCompass, text: "Guided Planning Support" },
    { icon: FiCamera, text: "Romantic Photo Locations" },
    { icon: FiHome, text: "Guest-Ready Setting" },
    { icon: FiUsers, text: "A Team That Handles the Rest" }
  ];

  return (
    <section className="py-24 px-6 bg-charcoal">
      <div className="max-w-4xl mx-auto border border-gold/20 p-8 md:p-16 relative">
        {/* Corner Accents */}
        <div className="absolute top-0 left-0 w-8 h-8 border-t border-l border-gold"></div>
        <div className="absolute top-0 right-0 w-8 h-8 border-t border-r border-gold"></div>
        <div className="absolute bottom-0 left-0 w-8 h-8 border-b border-l border-gold"></div>
        <div className="absolute bottom-0 right-0 w-8 h-8 border-b border-r border-gold"></div>

        <FadeIn className="text-center mb-12">
          <h2 className="font-serif text-3xl md:text-4xl text-ivory mb-6">Planned With Care, <span className="italic text-stone">Even On a Shorter Timeline</span></h2>
          <p className="text-stone font-light leading-relaxed max-w-2xl mx-auto">
            A last-minute date does not have to feel rushed. With the right venue team, the experience can still feel intentional, elegant, and fully supported.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 text-center mt-12">
          {points.map((point, index) => (
            <FadeIn key={index} delay={0.1 * index} className="flex flex-col items-center">
              <SafeIcon icon={point.icon} className="text-gold text-2xl mb-4 opacity-80" />
              <p className="font-serif text-lg text-ivory">{point.text}</p>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LastMinute;